import React, { Component } from 'react';
import './ModalProductDescription.css';
import ENV from '../../environments/environment'

declare var $;

class ModalProductDescription extends Component {
  constructor(props) {
    super(props)
  }

  componentDidMount() {
     $('.modal').modal();
  }

  render() {
    return (
      <div id="product" className="modal">
        <div className="modal-content center">
          <img src={ENV.getImageUrl() + this.props.product.image} />
          <h4>{this.props.product.name}</h4>
          <p>{this.props.product.description} - ${this.props.product.price}</p>
        </div>
        <div className="modal-footer">
          <a className="modal-action modal-close waves-effect waves-green btn-flat">Cerrar</a>
        </div>
     </div>
    );
  }
}


export default ModalProductDescription;



// WEBPACK FOOTER //
// ./src/components/modal-product-description/ModalProductDescription.js